import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ dataComponents: { pagination } }: ComposedTheme) => ({
  activePage: pagination.activePageText.font,
  pageEllipsis: {
    color: pagination.pageEllipsisColor,
    lineHeight: '20px',
  },
});

export default createUseStyles(styles);
